<template>
  <div class="all-tools-page">
    <!-- 左側搜索與篩選欄 -->
    <div class="sidebar">
      <h1>Tools</h1>
      <input type="text" placeholder="搜尋工具..." class="search-bar" />

      <div class="filters">
        <h2>篩選條件</h2>
        <div class="filter-tags">
          <button class="filter-tag" v-for="tag in filterTags" :key="tag">{{ tag }}</button>
        </div>
      </div>

      <div class="featured-section">
        <h2>精選</h2>
        <div class="featured-item">
          <img src="featured-image.jpg" alt="Featured Tool" class="featured-image"/>
          <div class="featured-info">
            <h3>Featured Tool Name</h3>
            <p>這是精選工具的簡介描述...</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 右側工具列表 -->
    <div class="tools-list">
      <div v-for="tool in tools" :key="tool.id" class="tool-card">
        <!-- 卡片頂部的粗線 -->
        <div class="tool-top-border"></div>

        <!-- 工具卡片內容 -->
        <div class="tool-content">
          <!-- 標題與下載次數 -->
          <div class="tool-header">
            <h3 class="tool-name">{{ tool.name }}</h3>
            <span class="tool-downloads">+{{ tool.downloads }}</span>
          </div>

          <!-- 工具簡介 -->
          <p class="tool-description">{{ tool.description }}</p>

          <!-- 標籤 -->
          <div class="tool-tags">
            <span class="tool-tag" v-for="tag in tool.tags" :key="tag">{{ tag }}</span>
          </div>

          <!-- Website 按鈕 -->
          <router-link :to="`/tools/${tool.id}`" class="tool-link">website</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllTools',
  data() {
    return {
      tools: [
        { id: 1, name: 'ToolNameHere 1', description: '這是第一個工具的描述。', downloads: 19098, tags: ['AI', '熱門'] },
        { id: 2, name: 'ToolNameHere 2', description: '這是第二個工具的描述。', downloads: 15075, tags: ['資料分析'] },
        { id: 3, name: 'ToolNameHere 3', description: '這是第三個工具的描述。', downloads: 12045, tags: ['App'] },
        { id: 4, name: 'ToolNameHere 4', description: '這是第四個工具的描述。', downloads: 19098, tags: ['AI', '熱門'] },
        { id: 5, name: 'ToolNameHere 5', description: '這是第五個工具的描述。', downloads: 15075, tags: ['資料分析'] },
        { id: 6, name: 'ToolNameHere 6', description: '這是第六個工具的描述。', downloads: 12045, tags: ['App'] }
      ],
      filterTags: ['熱門工具', '新工具', 'AI', '資料分析', 'App', 'Framework', 'LLM', '其他'],
    };
  },
};
</script>

<style scoped>
.all-tools-page {
  display: grid;
  grid-template-columns: 1fr 3fr; /* 左側1/4 右側3/4 */
  gap: 20px;
  padding: 20px;
  background-color: #f0f0f0;
}

.sidebar {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.search-bar {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filters h2 {
  margin-bottom: 10px;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-tag {
  padding: 5px 10px;
  background-color: #f1f1f1;
  border-radius: 16px;
  border: 1px solid #ccc; /* 添加外框線 */
  cursor: pointer;
  transition: background-color 0.3s;
}

.filter-tag:hover {
  background-color: #d1d1d1;
}

.featured-section {
  margin-top: 20px;
}

.featured-item {
  display: flex;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.featured-image {
  width: 100px;
  height: 80px;
  margin-right: 20px;
}

.featured-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.featured-info h3 {
  margin: 0;
}

/* 右側工具列表 */
.tools-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 每行顯示三個工具 */
  gap: 20px;
}

.tool-card {
  display: flex;
  flex-direction: column;
  padding: 15px;
  position: relative;
  background-color: transparent; /* 無背景色 */
  transition: transform 0.3s, box-shadow 0.3s; /* 添加過渡效果 */
}

.tool-card:hover {
  transform: translateY(-5px); /* 上移效果 */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* 添加陰影 */
}

.tool-top-border {
  height: 5px;
  background-color: #333; /* 粗線顏色 */
  border-radius: 8px 8px 0 0;
  margin-bottom: 10px;
}

.tool-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.tool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tool-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tool-downloads {
  font-size: 12px;
  color: #999;
}

.tool-description {
  font-size: 14px;
  color: #666;
  margin: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tool-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 5px 0;
}

.tool-tag {
  padding: 2px 8px;
  font-size: 12px;
  color: #333;
  border: 1px solid #ccc; /* 添加外框線 */
  border-radius: 4px;
}

.tool-link {
  font-size: 14px;
  color: #000; /* 改為黑色 */
  text-decoration: none;
  margin-top: auto;
  align-self: flex-start; /* 靠左對齊 */
}

.tool-link:hover {
  color: #333;
}
</style>
